// 电子合同
export const electronicContractRouter = [
  {
    path: '/service/electronicContract/manager',
    name: 'ElectronicContractManager',
    component: () => import('@/views/service/serviceProvider/electronicContract/ElectronicContractManager'),
    meta: {
      maxStyle: true,
      title: '电子合同',
      keepAlive: false
    }
  },
  {
    path: '/service/electronicContract/detail',
    name: 'ElectronicContractDetail',
    component: () => import('@/views/service/serviceProvider/electronicContract/ElectronicContractDetail'),
    meta: {
      maxStyle: true,
      title: '电子合同信息',
      keepAlive: false
    }
  }
]
